import api from '@/services/api';

export interface SlackConnection {
    connected: boolean;
    teamName?: string;
    teamId?: string;
    connectedAt?: string;
}

const BASE = '/v2/slack';

/**
 * Begin the "Add to Slack" OAuth flow. Returns the Slack authorize URL the
 * caller should navigate the browser to (`window.location.assign`).
 */
export async function getSlackInstallUrl(workspaceId?: string): Promise<string> {
    const { data } = await api.get<{ authorizeUrl: string }>(`${BASE}/oauth/install`, {
        params: workspaceId ? { workspaceId } : undefined,
    });
    return data.authorizeUrl;
}

/** Fetch the current Slack connection status for the active org + workspace. */
export async function getSlackConnection(workspaceId?: string): Promise<SlackConnection> {
    const { data } = await api.get<SlackConnection>(`${BASE}/connection`, {
        params: workspaceId ? { workspaceId } : undefined,
    });
    return data;
}

/** One connected Slack workspace (a Lantern workspace may have several). */
export interface SlackWorkspaceConnection {
    teamId: string;
    teamName: string;
    appId?: string | null;
    connectedAt?: string;
}

/** List every connected Slack workspace for the active org + workspace. */
export async function getSlackConnections(workspaceId?: string): Promise<SlackWorkspaceConnection[]> {
    const { data } = await api.get<{ connections: SlackWorkspaceConnection[] }>(`${BASE}/connections`, {
        params: workspaceId ? { workspaceId } : undefined,
    });
    return data.connections ?? [];
}

/** Disconnect one Slack workspace by its Slack team id. */
export async function disconnectSlack(teamId: string, workspaceId?: string): Promise<void> {
    await api.post(
        `${BASE}/disconnect`,
        { teamId },
        { params: workspaceId ? { workspaceId } : undefined },
    );
}
